<template>
  <div>
    <!-- 上传插件的对话框 -->
    <el-dialog :title="title" :visible.sync="dialog.visible" width="40%" append-to-body :modal-append-to-body="false"
      @closed="closed" :close-on-click-modal="true">
      <div>
        <!-- 表单 -->
        <el-form ref="form" :disabled="dialog.disabled" :model="form" :rules="rules" label-width="120px">
          <!-- 插件ID 下拉选择 单选-->
          <el-form-item label="关联插件：" prop="pluginId">
            <el-select style="width: 100%;" v-model="form.pluginId" placeholder="请选择插件ID" size="small" clearable
              @change="pluginChange">
              <el-option v-for="item in pluginIdList" :key="item.pluginId" :label="`[${item.pluginCode}]-${item.name}-${item.ver}`"
                :value="item.pluginId" />
            </el-select>
          </el-form-item>
          <!-- 策略名称 -->
          <el-form-item label="策略名称：" prop="name">
            <el-input clearable v-model="form.name" placeholder="请输入策略名称" maxlength="32" size="small"></el-input>
          </el-form-item>
          <!-- 加载方式 0手动 1自动-->
          <el-form-item label="加载方式：" prop="loadType">
            <el-radio-group v-model="form.loadType">
              <el-radio label="0">手动</el-radio>
              <el-radio label="1">自动</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 优先级 -->
          <el-form-item label="优先级：" prop="priority">
            <el-input type="number" v-model="form.priority" placeholder="输入正整数，按数字从大到小进行命中" size="small"></el-input>
          </el-form-item>
          <!-- 维度配置 -->
          <div class="container">
            <!-- 配置类型 -->
            <el-form-item label="配置类型：" prop="appType">
              <el-radio-group v-model="form.appType">
                <el-radio label="1">渠道</el-radio>
                <el-radio label="2">平台</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- 渠道相关配置 只有在配置类型是渠道才显示 -->
            <el-form-item v-if="form.appType === '1'" label="配置渠道：" prop="channel.type">
              <el-radio-group v-model="form.channel.type">
                <el-radio label="0">全部渠道</el-radio>
                <el-radio label="1">指定渠道</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- 终端类型 -->
            <el-form-item key="form.channel.channelInfoList[0].terminalType"
              v-if="form.appType === '1' && form.channel.type === '0'" label="终端类型："
              prop="channel.channelInfoList[0].terminalType">
              <el-checkbox :indeterminate="form.channel.channelInfoList[0].terminalType.length === 1"
                v-model="terminalTypeAll" @change="(val) => {
                  handleCheckAllChange(val, 1)
                }">全选</el-checkbox>
              <el-checkbox-group v-model="form.channel.channelInfoList[0].terminalType">
                <el-checkbox label="1">发送端</el-checkbox>
                <el-checkbox label="2">接收端</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <!-- 渠道选择组件 -->
            <el-form-item key="channel.channelInfoList[0].channelName"
              v-if="form.appType === '1' && form.channel.type === '1'" label="渠道(appID)："
              prop="channel.channelInfoList[0].channelName">
              <el-input type="textarea" @focus="channelClick()" v-model="form.channel.channelInfoList[0].channelName">
              </el-input>
            </el-form-item>
            <!-- 平台相关配置 只有在配置类型是平台才显示-->
            <!-- 定制类型 -->
            <el-form-item key="platform.customizedTypeList" v-if="form.appType === '2'" label="定制类型："
              prop="platform.customizedTypeList">
              <el-checkbox :indeterminate="form.platform.customizedTypeList.length === 1" v-model="customizedTypeListAll"
                @change="(val) => {
                  handleCheckAllChange(val, 2)
                }">全选</el-checkbox>
              <el-checkbox-group v-model="form.platform.customizedTypeList">
                <el-checkbox label="1">SDK</el-checkbox>
                <el-checkbox label="2">APP</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <!-- 发端类型 -->
            <el-form-item key="platform.platformMap.1" v-if="form.appType === '2'" label="发端类型："
              prop="platform.platformMap.1">
              <el-checkbox
                :indeterminate="Object.entries(form.platform.platformMap['1']).length > 0 && Object.entries(form.platform.platformMap['1']).length < 6"
                v-model="sendPlatformAll" @change="(val) => { handleCheckAllChange(val, 3) }">全选</el-checkbox>
              <el-checkbox-group v-model="form.platform.platformMap['1']">
                <el-checkbox class="tips" label="Android">Android <span class="tips-content">(二选一)</span></el-checkbox>
                <el-checkbox label="IOS">IOS</el-checkbox>
                <el-checkbox label="Windows">Windows</el-checkbox>
                <el-checkbox label="MAC">MAC</el-checkbox>
                <el-checkbox label="web">web</el-checkbox>
                <el-checkbox label="weixin">微信小程序</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <!-- 收端类型 -->
            <el-form-item key="platform.platformMap.2" v-if="form.appType === '2'" label="收端类型："
              prop="platform.platformMap.2">
              <el-checkbox
                :indeterminate="Object.entries(form.platform.platformMap['2']).length > 0 && Object.entries(form.platform.platformMap['2']).length < 5"
                v-model="receivePlatformAll" @change="(val) => { handleCheckAllChange(val, 4) }">全选</el-checkbox>
              <el-checkbox-group v-model="form.platform.platformMap['2']">
                <el-checkbox class="tips" label="Android">Android（TV）<span
                    class="tips-content2">(二选一)</span></el-checkbox>
                <el-checkbox label="Windows">Windows</el-checkbox>
                <el-checkbox label="MAC">MAC</el-checkbox>
                <el-checkbox label="Linux">Linux</el-checkbox>
                <el-checkbox label="cloudApp">云应用</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <!-- 说明 -->
            <el-form-item v-if="form.appType === '2'" label=" ">
              <span
                style="font-size: 12px;color: #a4a4a4;">说明：前置条件之间为或的关系，例如只选择Android、iOS，则代表Android、iOS皆会命中，其中未选择的端不会命中</span>
            </el-form-item>
            <!-- br -->
            <br>
            <!-- 厂商 -->
            <el-form-item label="厂商：" prop="manufacturer">
              <el-input clearable v-model="form.manufacturer" placeholder="厂商标识，例如：小米" maxlength="64"
                size="small"></el-input>
            </el-form-item>
            <!-- 品牌 -->
            <el-form-item label="品牌：" prop="brand">
              <el-input clearable v-model="form.brand" placeholder="品牌标识，例如：migu" maxlength="64" size="small"></el-input>
            </el-form-item>
            <!-- 型号 -->
            <el-form-item label="型号：" prop="model">
              <el-input clearable v-model="form.model" placeholder="型号标识，例如：小米盒子BOX" maxlength="64"
                size="small"></el-input>
            </el-form-item>
            <!-- uid -->
            <el-form-item label="uid：" prop="uid">
              <el-input clearable v-model="form.uid" placeholder="设备UID" maxlength="64" size="small"></el-input>
            </el-form-item>
            <!-- uuid -->
            <el-form-item label="uuid：" prop="uuid">
              <el-input clearable v-model="form.uuid" placeholder="用户uuid" maxlength="64" size="small"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" style="flex-end">
        <el-button size="small" @click="hide">取 消</el-button>
        <el-button size="small" type="primary" @click="confirm">保 存</el-button>
      </span>
    </el-dialog>
    <channel-popups :app-id="channelForm.channelId" :visible.sync="channelForm.showPopups"
      @comfirm="channelConfirm"></channel-popups>
  </div>
</template>

<script>
import Message from "@/components/Message"
import ChannelPopups from '@/components/channel-popups';
import { getPluginsList, addPluginsTactics, editPluginsTactics } from "@/api/pluginManage/pluginTactics"
import { handleAddFormData } from "../utils/index"
export default {
  name: "WebSaaSAdd",
  inject: ['loadList'],
  components: {
    ChannelPopups
  },
  computed: {
    // 对话框标题
    title() {
      return this.form.id ? "编辑策略" : "新增策略";
    },
    // 终端类型是否全部选中
    terminalTypeAll() {
      return this.form.channel.channelInfoList[0].terminalType.length === 2
    },
    // 定制类型是否全部选中
    customizedTypeListAll() {
      return this.form.platform.customizedTypeList.length === 2
    },
    // 发端类型是否全部选中
    sendPlatformAll() {
      return this.form.platform.platformMap['1'].length === 6
    },
    // 收端类型是否全部选中
    receivePlatformAll() {
      return this.form.platform.platformMap['2'].length === 5
    },
  },
  data() {
    return {
      // 对话框
      dialog: {
        visible: false,
        disabled: false,
      },
      // 渠道选择框
      channelForm: {
        channelId: [],
        channelInfo: {
          'channelId': [],
          'channelName': [],
          'terminalType': []
        },
        showPopups: false
      },
      // 插件列表数据
      pluginIdList: [],
      // 表单
      form: {
        // 插件ID
        pluginId: '',
        // 插件编号
        pluginCode: '',
        // 策略名称
        name: '',
        // 加载方式
        loadType: '0',
        // 优先级
        priority: '',
        // 配置类型
        appType: '1',
        // 渠道数据
        channel: {
          // 渠道配置类型: 0全部渠道 1指定渠道
          type: '0',
          // 渠道明细列表
          channelInfoList: [{
            // 每个渠道的终端类型: 1发送端 2接收端
            terminalType: [],
            // 渠道名称
            channelName: '',
            // 渠道id，0表示全部渠道
            channelId: ''
          }]
        },
        // 平台数据
        platform: {
          // 定制类型: 1-SDK 2-APP
          customizedTypeList: [],
          // key为终端类型: 1发送端 2接收端，value为平台列表：Android、IOS、Windows、MAC、Linux、web、weixin、cloudApp
          platformMap: {
            '1': [],
            '2': []
          }
        },
        // 厂商
        manufacturer: '',
        // 品牌
        brand: '',
        // 型号
        model: '',
        // uid
        uid: '',
        // uuid
        uuid: ''
      },
      // 表单验证规则
      rules: {
        pluginId: [{ required: true, message: "请选择插件ID", trigger: "blur" }],
        name: [{ required: true, message: "请输入策略名称", trigger: "blur" }],
        loadType: [{ required: true, message: "请选择加载方式", trigger: "blur" }],
        priority: [{
          required: true, trigger: ["change", 'blur'],
          validator: (rule, value, callback) => {
            // 只能是正整数
            if (!/^[1-9]\d*$/.test(this.form.priority)) {
              return callback(new Error("请输入正整数"));
            }
            callback();
          },
        }],
        appType: [{ required: true, message: "请选择配置类型", trigger: "blur" }],
        'channel.type': [{ required: true, message: "请选择配置渠道", trigger: "blur" }],
        'channel.channelInfoList[0].terminalType': [{ required: true, message: "请选择终端类型", trigger: ["change"] }],
        'channel.channelInfoList[0].channelName': [{ required: true, message: "请选择渠道", trigger: ["change", "blur"] }],
        'platform.customizedTypeList': [{ required: true, message: "请选择定制类型", trigger: ["change", "blur"], }
          , {
          type: "array",
        }],
        'platform.platformMap.1': [{
          required: false, trigger: ["change", "blur"], validator: (rule, value, callback) => {
            if (Object.entries(this.form.platform.platformMap['1']).length === 0 && Object.entries(this.form.platform.platformMap['2']).length === 0) {
              return callback(
                new Error("收发端类型至少二选一")
              );
            }
            callback();
          },
        }],
        'platform.platformMap.2': [{
          required: false, validator: (rule, value, callback) => {
            if (Object.entries(this.form.platform.platformMap['1']).length === 0 && Object.entries(this.form.platform.platformMap['2']).length === 0) {
              return callback(
                new Error("收发端类型至少二选一")
              );
            }
            callback();
          }, trigger: ["change", "blur"]
        }],
        manufacturer: [{ required: false, message: "请输入厂商", trigger: "blur" }],
        brand: [{ required: false, message: "请输入品牌", trigger: "blur" }],
        model: [{ required: false, message: "请输入型号", trigger: "blur" }],
        uid: [{ required: false, message: "请输入uid", trigger: "blur" }],
        uuid: [{ required: false, message: "请输入uuid", trigger: "blur" }]
      },
    };
  },

  methods: {
    /** 新增的方法 */
    async add(params) {
      const { data } = await addPluginsTactics(params)
      console.log("创建策略的响应", data);
      if (data.code === 200) {
        Message.success("新增成功");
        this.loadList();
        this.hide();
      }
    },
    /** 编辑的方法 */
    async edit(params) {
      const { data } = await editPluginsTactics(params)
      console.log("编辑策略的响应", data);
      if (data.code === 200) {
        Message.success("编辑成功");
        this.loadList();
        this.hide();
      }
    },
    /** 对话框保存 */
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log('表单数据', this.form);
          // 处理表单数据
          const params = handleAddFormData(this.form, this.channelForm.channelInfo);
          console.log('处理后的表单数据', params);
          // 新增
          if (!this.form.id) {
            this.add(params);
          } else {
            // 编辑
            this.edit(params);
          }
          // this.hide();
        } else {
          return false;
        }
      });
    },
    /** 全选的方法 */
    handleCheckAllChange(val, key) {
      console.log('全选框组的数据', val);
      /** 
       * key: 1-终端类型 2-定制类型 3-发端类型 4-收端类型
       */
      switch (key) {
        case 1:
          this.form.channel.channelInfoList[0].terminalType = val ? ['1', '2'] : [];
          break;
        case 2:
          this.form.platform.customizedTypeList = val ? ['1', '2'] : [];
          break;
        case 3:
          this.form.platform.platformMap['1'] = val ? ['Android', 'IOS', 'Windows', 'MAC', 'web', 'weixin'] : [];
          break;
        case 4:
          this.form.platform.platformMap['2'] = val ? ['Android', 'Windows', 'MAC', 'Linux', 'cloudApp'] : [];
          break;
        default:
          break;
      }
    },
    /** 点击指定渠道 */
    channelClick() {
      this.channelForm.showPopups = true
    },
    /** 确认选择渠道 */
    channelConfirm(data) {
      console.log('渠道选择框的数据', data);
      const { appId, nameStr, terminalType } = data;
      this.form.channel.channelInfoList[0].channelName = nameStr;
      // 这是指定渠道的时候需要遍历每一个渠道
      this.channelForm.channelInfo.channelId = appId.split(',');
      this.channelForm.channelInfo.channelName = nameStr.split(',');
      this.channelForm.channelInfo.terminalType = terminalType.split(',').map(item => parseInt(item));
      this.channelForm.channelId = appId
    },
    /** 选择关联插件 */
    pluginChange(val) {
      console.log('选择关联插件的值', val);
      if (val) {
        const plugin = this.pluginIdList.find(item => item.pluginId === val);
        console.log('查找到对应的插件', plugin);
        this.form.pluginCode = plugin.pluginCode || '';
      }
    },
    //^ ^--------------加载依赖数据-------------^ ^
    /** 加载插件列表数据 */
    async loadPluginList() {
      const { data } = await getPluginsList();
      console.log('加载插件列表数据的响应', data);
      this.pluginIdList = data.data.map(item => {
        return {
          pluginId: item.id,
          pluginCode: item.code,
          name: item.name,
          ver:item.ver
        }
      });
    },
    //^ ^--------------对话框自身的方法-------------^ ^
    show(row, channelInfo) {
      /** 加载插件列表数据 */
      this.loadPluginList();
      if (row) {
        console.log('show接收到的row', row, channelInfo);
        this.$set(this, 'form', row)
        this.$set(this.form, 'channel', row.channel)
        this.$set(this, 'channelForm', channelInfo)
        this.$set(this.channelForm, 'channelInfo', channelInfo.channelInfo)
        console.log(this.channelForm);
      }
      this.dialog.visible = true;
    },
    hide() {
      this.dialog.visible = false;
    },
    /** 关闭 */
    closed() {
      this.dialog.visible = false;
      // 表单重新赋值
      this.form = {
        pluginId: '',
        name: '',
        priority: '',
        appType: '1',
        channel: {
          type: '0',
          channelInfoList: [{
            terminalType: [],
            channelName: '',
            channelId: ''
          }]
        },
        platform: {
          customizedTypeList: [],
          platformMap: {
            '1': [],
            '2': []
          }
        },
        manufacturer: '',
        brand: '',
        model: '',
        uid: '',
        uuid: ''
      }
      this.channelForm =
      {
        channelInfo: {
          'channelId': [],
          'channelName': [],
          'terminalType': []
        },
        showPopups: false
      }
      // 清除表单验证规则
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #f4f4f4;
  padding: 10px;

  ::v-deep .tips {
    position: relative;

    /** 伪元素 */
    .tips-content {
      position: absolute;
      top: 25%;
      left: -104%;
      color: #afaeae;
    }

    .tips-content2 {
      position: absolute;
      top: 25%;
      left: -65%;
      color: #afaeae;
    }
  }
}
</style>